// Imported first in src/index.js, so telemetry starts before any other app module loads or renders
import { InitOtel } from './init';
import { initConsoleLogger } from './consoleLogger';

InitOtel({
  env: process.env.REACT_APP_ENV || 'dev',
  name: 'web-auth',
  version: `${process.env.REACT_APP_COMMIT_VERSION}`,
});
initConsoleLogger();
